<template>
  <div class="delivery">
    <div class="banner"></div>

    <div :class="this.isMobile.value ? 'profile-mobile' : 'profile'">
      <div class="profile-header">
        <div class="profile-header__title">
          <h2>供应商入库类型</h2>
        </div>
      </div>

      <div class="resumeForm">
        <!-- 基本信息 -->
        <div class="resumeViewSection">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="当前供应商入库类型" prop="oldMaterialTypes">
              <treeselect
                v-model="form.oldMaterialTypes"
                :options="materialTypeOptions"
                :disable-branch-nodes="false"
                :show-count="true"
                placeholder=""
                multiple
                collapseTags
                disabled
              >
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.position }}</div>
              </treeselect>
            </el-form-item>
<!--            <el-form-item label="新供应商入库类型" prop="newMaterialTypes">-->
<!--              <treeselect-->
<!--                v-model="form.newMaterialTypes"-->
<!--                :options="materialTypeOptions"-->
<!--                :disable-branch-nodes="true"-->
<!--                :show-count="true"-->
<!--                placeholder="请选择供应商入库类型"-->
<!--                multiple-->
<!--                collapseTags-->
<!--              >-->
<!--                <div slot="value-label" slot-scope="{ node }">{{ node.raw.position }}</div>-->
<!--              </treeselect>-->
<!--            </el-form-item>-->
<!--            <el-form-item>-->
<!--              <el-button type="danger" size="mini" @click="submit">保存</el-button>-->
<!--              <el-button size="mini" @click="close">关闭</el-button>-->
<!--            </el-form-item>-->
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { treeselect } from "@/api/purchase/purchaseMaterialType";
import { listUserMaterialRelation, addUserMaterialRelation, delUserMaterialRelation } from "@/api/purchase/userMaterialRelation";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import store from "@/store/index.js";
export default {
  name: "materialType",
  components: {
    Treeselect
  },
  data() {
    return {
      form: {
        oldMaterialTypes: [],
        newMaterialTypes: [],
      },
      //初始值
      show: "false",
      count: "",
      loading: false,
      redirect: undefined,
      rules: {
        newMaterialTypes: { required: true, trigger: "blur", message: "请输入新供应商入库类型" },
      },
      disabled: false,
      materialTypeOptions: [],
      oldMaterialTypeRelationIds: [],
      userInfo: store.state.userInfo
    };
  },

  created() {
    this.getTreeselect();
    this.getMaterialType();
  },

  methods: {
    getMaterialType(){
      if(this.userInfo.user){
        listUserMaterialRelation({
          userId: this.userInfo.user.id
        }).then(response => {
          this.form.oldMaterialTypes = response.rows.map(item => {
            return item.materialTypeId;
          });
          this.oldMaterialTypeRelationIds = response.rows.map(item => {
            return item.id;
          });
        });
      }
    },
    /** 查询下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        this.materialTypeOptions = response.data;
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let newMaterialTypes = this.form.newMaterialTypes;
          delUserMaterialRelation(this.oldMaterialTypeRelationIds).then((response) => {
            for (let i = 0; i < newMaterialTypes.length; i++) {
              addUserMaterialRelation({
                userId: this.userInfo.user.id,
                materialTypeId: newMaterialTypes[i]
              }).then((response2) => {
                this.getMaterialType();
                this.form.newMaterialTypes = [];
              });
            }
            this.$message({
              message: "修改成功！",
              type: "success",
            });
          });
        }
      });
    },

    close() {
      this.$router.push({ path: "/" });
    },

    reset() {
      this.form = {
        oldMaterialTypes: [],
        newMaterialTypes: [],
      };
    }
  }, //methods end
};
</script>

<style lang="less" scoped>
.banner {
  // width: 1200px;
  background-image: url("//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/my_resume_banner_1577084307030.jpg");
  background-size: 100% 100%;
  height: 300px;
  background-repeat: no-repeat;
}

.profile {
  width: 1100px;
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.profile-mobile {
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}
@media(max-width:960px){
  .banner{
    height: 210px !important;
  }
  .profile-header{
    margin-left: 20px !important;
  }
  .back-list{
    height: 60px;
    line-height: 60px;
  }
}
</style>
